"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIconButtonListStyles = void 0;
var core_1 = require("@material-ui/core");
var IconButtonList_1 = require("./IconButtonList");
var commons_1 = require("../../../style/commons");
exports.useIconButtonListStyles = (0, core_1.makeStyles)(function () {
    var _a;
    return (_a = {
            container: {
                display: 'table',
                position: 'relative',
                fontFamily: 'Roboto',
            },
            iconButton: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 4,
                border: 'none',
                backgroundColor: commons_1.darkBlue,
                height: 24,
                width: 24,
                padding: 0,
                color: commons_1.white,
                fontSize: 16,
            },
            actionsList: {
                position: 'absolute',
            }
        },
        _a[IconButtonList_1.IconButtonActionsPlacement.BOTTOM_START] = {
            left: 0,
            top: '100%',
            marginTop: 4,
        },
        _a[IconButtonList_1.IconButtonActionsPlacement.BOTTOM_END] = {
            right: 0,
            top: '100%',
            marginTop: 4,
        },
        _a[IconButtonList_1.IconButtonActionsPlacement.TOP_START] = {
            left: 0,
            bottom: '100%',
            marginBottom: 4,
        },
        _a[IconButtonList_1.IconButtonActionsPlacement.TOP_END] = {
            right: 0,
            bottom: '100%',
            marginBottom: 4,
        },
        _a);
});
